var _excluded = ["min", "max", "leftValue", "rightValue", "unit", "unitPosition", "onChange", "step", "sliderProps", "inputProps", "containerProps", "valuesProps", "disableMaxSlider", "customValues", "currentValues", "initialValues"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Div, Input, Label } from '@kizi/core-components';
export var MultiRangeSlider = function MultiRangeSlider(_ref) {
  var _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 100 : _ref$max,
      _ref$leftValue = _ref.leftValue,
      leftValue = _ref$leftValue === void 0 ? min : _ref$leftValue,
      _ref$rightValue = _ref.rightValue,
      rightValue = _ref$rightValue === void 0 ? max : _ref$rightValue,
      _ref$unit = _ref.unit,
      unit = _ref$unit === void 0 ? '€' : _ref$unit,
      _ref$unitPosition = _ref.unitPosition,
      unitPosition = _ref$unitPosition === void 0 ? 'left' : _ref$unitPosition,
      onChange = _ref.onChange,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      sliderProps = _ref.sliderProps,
      inputProps = _ref.inputProps,
      containerProps = _ref.containerProps,
      valuesProps = _ref.valuesProps,
      _ref$disableMaxSlider = _ref.disableMaxSlider,
      disableMaxSlider = _ref$disableMaxSlider === void 0 ? false : _ref$disableMaxSlider,
      customValues = _ref.customValues,
      currentValues = _ref.currentValues,
      initialValues = _ref.initialValues,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(customValues ? customValues[0] : leftValue),
      _useState2 = _slicedToArray(_useState, 2),
      minVal = _useState2[0],
      setMinVal = _useState2[1];

  var _useState3 = useState(customValues ? customValues[customValues.length - 1] : rightValue),
      _useState4 = _slicedToArray(_useState3, 2),
      maxVal = _useState4[0],
      setMaxVal = _useState4[1];

  var minValRef = useRef(null);
  var maxValRef = useRef(null);
  var range = useRef(null);
  var isFirstRender = useRef(true);
  var previousValuesRef = useRef(currentValues);

  var getClosestValue = function getClosestValue(value) {
    return customValues === null || customValues === void 0 ? void 0 : customValues.reduce(function (prev, curr) {
      return Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev;
    });
  };

  var handleChange = function handleChange(event) {
    if (customValues) {
      var value = parseInt(event.target.value, 10);
      var totalSteps = customValues.length - 1;
      var stepValue = Math.round(value / 100 * totalSteps);
      var closestValue = customValues[stepValue];
      setMinVal(getClosestValue(closestValue) || 0);
    } else {
      var _value = Math.min(+event.target.value, maxVal - step);

      setMinVal(_value);
    }
  };

  var findStepValueForInput = function findStepValueForInput(inputValue) {
    if (customValues) {
      var index = customValues.indexOf(inputValue);
      var stepValue = Math.round(index / (customValues.length - 1) * 100);
      return stepValue;
    }

    return null;
  };

  var getPercent = useCallback(function (value) {
    return Math.round((value - min) / (max - min) * 100);
  }, [min, max]);
  var generateLabel = useCallback(function () {
    if (disableMaxSlider) {
      return "Minimaal ".concat(minVal, " ").concat(unit);
    }

    if (unitPosition === 'left') {
      return "".concat(unit, " ").concat(minVal, " - ").concat(unit, " ").concat(maxVal);
    } else {
      return "".concat(minVal, " ").concat(unit, " - ").concat(maxVal, " ").concat(unit);
    }
  }, [minVal, maxVal]);
  useEffect(function () {
    if (maxValRef.current) {
      var minPercent;
      var maxPercent;

      if (customValues) {
        minPercent = findStepValueForInput(minVal);
        maxPercent = disableMaxSlider ? 100 : findStepValueForInput(maxVal);
      } else {
        minPercent = getPercent(minVal);
        maxPercent = disableMaxSlider ? 100 : getPercent(maxVal);
      }

      if (range.current) {
        range.current.style.left = "".concat(minPercent, "%");
        range.current.style.width = "".concat(maxPercent - minPercent, "%");
      }
    }
  }, [minVal, getPercent]);
  useEffect(function () {
    if (minValRef.current && !disableMaxSlider) {
      var minPercent;
      var maxPercent;

      if (customValues) {
        minPercent = findStepValueForInput(minVal);
        maxPercent = findStepValueForInput(maxVal);
      } else {
        minPercent = getPercent(+minValRef.current.value);
        maxPercent = getPercent(maxVal);
      }

      if (range.current) {
        range.current.style.width = "".concat(maxPercent - minPercent, "%");
      }
    }
  }, [maxVal, getPercent]);
  useEffect(function () {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      if (currentValues) {
        setMinVal(currentValues[0]);
        setMaxVal(currentValues[1]);
      }

      return;
    }

    onChange && onChange({
      min: minVal,
      max: maxVal
    });
  }, [minVal, maxVal]);
  useEffect(function () {
    if (!currentValues || !initialValues) {
      return;
    }

    var valuesChanged = !previousValuesRef.current || previousValuesRef.current[0] !== currentValues[0] || previousValuesRef.current[1] !== currentValues[1];
    previousValuesRef.current = currentValues;

    if (valuesChanged && initialValues[0] === currentValues[0] && initialValues[1] === currentValues[1]) {
      setMinVal(initialValues[0]);
      setMaxVal(initialValues[1]);
    }
  }, [currentValues, initialValues]);
  return /*#__PURE__*/React.createElement(Div, _extends({
    position: "relative"
  }, containerProps, restProps), /*#__PURE__*/React.createElement(Label, _extends({
    "data-testid": "valuesLabel",
    display: "block",
    mb: 3,
    color: 'main.1'
  }, valuesProps), generateLabel()), /*#__PURE__*/React.createElement(Input, _extends({
    type: "range",
    variant: "rangeSliderInput",
    step: customValues ? '1' : step,
    min: customValues ? '0' : min,
    max: customValues ? '100' : max,
    value: customValues ? (customValues.indexOf(minVal) / (customValues.length - 1) * 100).toString() : minVal,
    ref: minValRef,
    onChange: handleChange
  }, inputProps)), /*#__PURE__*/React.createElement(Div, {
    display: disableMaxSlider ? 'none' : 'block'
  }, /*#__PURE__*/React.createElement(Input, _extends({
    type: "range",
    variant: "rangeSliderInput",
    min: customValues ? '0' : min,
    max: customValues ? '100' : max,
    step: customValues ? '1' : step,
    value: customValues ? (customValues.indexOf(maxVal) / (customValues.length - 1) * 100).toString() : maxVal,
    ref: maxValRef,
    onChange: function onChange(event) {
      if (customValues) {
        var value = parseInt(event.target.value, 10);
        var totalSteps = customValues.length - 1;
        var stepValue = Math.round(value / 100 * totalSteps);
        var closestValue = customValues[stepValue];

        if (closestValue > minVal) {
          setMaxVal(closestValue);
        }
      } else {
        var _value2 = Math.max(+event.target.value, minVal + step);

        setMaxVal(_value2);
      }
    }
  }, inputProps))), /*#__PURE__*/React.createElement(Div, _extends({
    variant: "rangeSlider"
  }, sliderProps), /*#__PURE__*/React.createElement(Div, null), /*#__PURE__*/React.createElement(Div, {
    ref: range
  })));
};